import React from "react";
import { t } from "ttag";

import type { ShowroomLocationsGalleryBlock as Value } from "@reactivated";

import { ShowroomLocation } from "./ShowroomLocation";

import styles from "./index.module.scss";

function slugify(name: string): string {
    return name
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
}

export const ShowroomLocationsGalleryBlock = (props: { value: Value }) => {
    if (!props.value.locations.length) {
        return null;
    }

    return (
        <section className={styles.root}>
            <h2 className={styles.heading}>{t`Locations`}</h2>
            <nav
                className={styles.anchorNav}
                aria-label={t`Showroom locations`}
            >
                {props.value.locations.map((loc) => {
                    const slug = slugify(loc.display_name);
                    return (
                        <a
                            key={loc.id}
                            href={`#showroom-${slug}`}
                            className={styles.anchorLink}
                            onClick={(e) => {
                                e.preventDefault();
                                const hash = `#showroom-${slug}`;
                                document
                                    .getElementById(`showroom-${slug}`)
                                    ?.scrollIntoView({ behavior: "smooth" });
                                history.replaceState(null, "", hash);
                            }}
                        >
                            {loc.city}
                        </a>
                    );
                })}
            </nav>
            <div className={styles.locations}>
                {props.value.locations.map((loc) => (
                    <ShowroomLocation
                        key={loc.id}
                        location={loc}
                        slug={slugify(loc.display_name)}
                    />
                ))}
            </div>
        </section>
    );
};
